import { createTheme, lightTheme } from '@common-ui/ui';
// Please refer to this object:
// https://mui.com/customization/default-theme/?expand-path=$.palette
// any stylings that will be added need to overwrite the data from this object
const TIComponentTheme = createTheme(lightTheme, {
  palette: {
    mode: 'light',
    height: '100vh',
    primary: {
      main: '#ffc20e',
    },
    secondary: {
      main: '#1769aa',
    },
    text: {
      primary: '#000',
      secondary: '#000',
    },
  },
});

export default TIComponentTheme;
